// Converts common YouTube URL forms into an embeddable URL; other links pass through unchanged
export const getEmbedUrl = (link: string): string => {
    try {
        const url = new URL(link);
        const host = url.hostname.replace(/^www\./, "");
        if (host === "youtu.be") {
            return `https://www.youtube.com/embed${url.pathname}`;
        }
        if (host.endsWith("youtube.com")) {
            const v = url.searchParams.get("v");
            if (v) return `https://www.youtube.com/embed/${v}`;
            const match = url.pathname.match(/^\/(live|shorts|embed)\/([^/]+)/);
            if (match) return `https://www.youtube.com/embed/${match[2]}`;
        }
        return link;
    } catch {
        return link;
    }
};
